import { Component, Inject, OnInit } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RichTextEditorComponent } from '../../shared/rich-textEditor/rich-textEditor.component'; // Import FormsModule
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { RequestForQuotationService } from '@/app/services/tendering-services/rfq/rfq.service';

@Component({
  selector: 'app-approval-response',
  standalone: true,
  imports: [
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    CommonModule,
    FormsModule,
    RichTextEditorComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './approval-response.component.html',
  styleUrl: './approval-response.component.css',
})
export class ApprovalResponseComponent implements OnInit {
  senderDetail: { description?: string; userName?: string; userTitle?: string } = {};

  constructor(
    private dialogRef: MatDialogRef<ApprovalResponseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private tenderingService: TenderingService,
    private requestForQuotationService: RequestForQuotationService
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      approver_note: new FormControl(''),
      status: new FormControl('', Validators.required), // Add status control
    });
    console.log('res data',this.data.approvalSender);
    
  }

  form: FormGroup;
  resetRichTextEditor = false;

  approverNote(content: string) {
    this.form.controls['approver_note'].setValue(content);
  }

  getSanitizedHtml(note: string) {
    if (!note) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(note);
  }

  prepareDataToSubmit() {
    const data = {
      status: this.form.value.status, // Get the selected status
      comment: this.form.value.approver_note, // Get the approver note
    };

    return data;
  }

  sendApproval() {
    const dataToSubmit = this.prepareDataToSubmit();
    if (this.data?.modalType === 'itt') {
      this.tenderingService
        .sendIttApprovalResponse(
          dataToSubmit,
          this.data?.projectId,
          this.data?.modalType,
          this.data?.ResponseId
        )
        .subscribe({
          next: (response: any) => {
            this.toast.success(response.meta.message, 'SUCCESS', 4000);
            this.closeApproval();
          },
          error: (error: any) => {
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    } else if (this.data?.modalType === 'rfq') {
      this.requestForQuotationService
        .sendRfqApprovalResponse(
          dataToSubmit,
          this.data?.projectId,
          this.data?.modalType,
          this.data?.ResponseId
        )
        .subscribe({
          next: (response: any) => {
            this.toast.success(response.meta.message, 'SUCCESS', 4000);
            this.closeApproval();
            console.log("response" ,response);
            
          },
          error: (error: any) => {
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    } else {
      this.projectsService
        .sendApprovalResponse(
          this.data?.projectId,
          this.data?.ResponseId,
          dataToSubmit,
          this.data?.modalType,
          
        )
        .subscribe({
          next: (response: any) => { 
            if (response?.data?.internal_approvals?.internal_approval_responses?.length) {
              const sender = response.data;
              this.senderDetail = {
                userName: sender?.name,
                userTitle: sender?.title,
                description: sender?.comment,
              };}
            this.toast.success(response.meta.message, 'SUCCESS', 4000);
            this.closeApproval();
          },
          error: (error: any) => {
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    }
  }

  // if (response?.data) {
  //   this.senderDetail = {
  //     description: response?.data[0]?.notes,
  //     userName: response?.data[0]?.created_by?.name,
  //     userTitle: response?.data[0]?.subject,
  //   };
  //   console.log(this.senderDetail);
  //   console.log(response?.data);
    
  // }

  closeApproval() {
    this.dialogRef.close('closeApproval');
  }
}
